export default {
  title: 'Creează cheie API',
  reveal_warning: 'Salvează această cheie acum — nu va mai fi afișată din nou.',
  form: {
    name: 'Nume',
    name_placeholder: 'ex. Cheie de producție',
  },
  buttons: {
    cancel: 'Anulează',
    create: 'Creează',
    done: 'Gata',
  },
  toasts: {
    error: 'Cheia nu a putut fi creată. Te rugăm să încerci din nou.',
  },
};
